import {useDispatch} from "react-redux";
import {setPanierReference} from "../store/actions";
import useHttpClient from "./http/useHttpClient";

export const useGenerateReference = (): () => Promise<void> => {
    const dispatch = useDispatch()
    const {getOrderDetail} = useHttpClient()

    const generateReference = (): string => {
        let result = `B`
        for ( let i = 0; i < 12 ; i++ ) {
            result += Math.floor(Math.random() * 10);
        }
        return result
    }

    return async (): Promise<void> => {
        let reference;
        let exist;
        do {
            reference = generateReference();
            exist = await getOrderDetail(reference)
                .catch(() => console.log("la référence n'existe pas"))
        } while (exist)
        dispatch(setPanierReference(reference))
        return Promise.resolve();
    }
}
